module.exports = __webpack_public_path__ + "img/020055.ce14b5ee.png";